import type { StatusCandidato } from '../../models';

export const STATUS_CANDIDATO_LABELS: Record<StatusCandidato, string> = {
  aguardando_envio: 'Aguardando envio do link',
  aguardando_preenchimento: 'Aguardando preenchimento',
  preenchido: 'Preenchido',
  proposta_aceita: 'Proposta aceita',
  proposta_recusada: 'Proposta recusada',
  aguardando_preenchimento_etapa2: 'Aguardando Etapa 2',
  preenchido_etapa2: 'Etapa 2 concluída',
};

export const STATUS_CANDIDATO_BADGE_CLASS: Record<StatusCandidato, string> = {
  aguardando_envio: 'bg-gray-100 text-gray-700',
  aguardando_preenchimento: 'bg-amber-100 text-amber-800',
  preenchido: 'bg-green-100 text-green-800',
  proposta_aceita: 'bg-indigo-100 text-indigo-800',
  proposta_recusada: 'bg-red-100 text-red-800',
  aguardando_preenchimento_etapa2: 'bg-amber-100 text-amber-800',
  preenchido_etapa2: 'bg-green-100 text-green-800',
};
